// extracted by mini-css-extract-plugin
export default {"text":"KgMm7T","lineClamp":"MpIlbv"};